// removed by extract-text-webpack-plugin
module.exports = {"buttonSearch":"styles__buttonSearch___26Z6w","buttonSearchIcon":"styles__buttonSearchIcon___2-ylV"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/button/styles.css
// module id = +tt+
// module chunks = 2